<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
    <div style="page-break-inside: avoid">
        <h5>{{title}}</h5>
        <table class="optionalComponentSectionTable">
            <tr>
                <td>
                    <div *ngIf="solar.solarPvTypes && solar.solarPvTypes.length > 0" style="float: left; width: 45%;">
                        Solar PV:
                        <ul>
                            <li *ngFor="let pv of solar.solarPvTypes">
                                {{pv.description}}
                            </li>
                        </ul>
                    </div>

                    <div *ngIf="solar.solarCspTypes && solar.solarCspTypes.length > 0" style="float: left; width: 45%;">
                        Solar CSP:
                        <ul>
                            <li *ngFor="let csp of solar.solarCspTypes">
                                {{csp.description}}
                            </li>
                        </ul>
                    </div>

                    <div style="clear: both;"></div>
                </td>
            </tr>
        </table>
    </div>
</ng-template>

<ng-template #template_mobile let-title="title">
    <div style="page-break-inside: avoid">
        <h5>{{title}}</h5>
        <table class="optionalComponentSectionTable">
            <tr>
                <td>
                    <div *ngIf="solarPvTypes && solarPvTypes.length > 0" style="float: left; width: 45%;">
                        Solar PV:
                        <ul>
                            <li *ngFor="let pv of solarPvTypes">
                                {{pv.description}}
                            </li>
                        </ul>
                    </div>

                    <div *ngIf="solarCspTypes && solarCspTypes.length > 0" style="float: left; width: 45%;">
                        Solar CSP:
                        <ul>
                            <li *ngFor="let csp of solarCspTypes">
                                {{csp.description}}
                            </li>
                        </ul>
                    </div>

                    <div style="clear: both;"></div>
                </td>
            </tr>
        </table>
    </div>
</ng-template>